// extracted by mini-css-extract-plugin
module.exports = {"followButton":"styles_followButton__LAzHl","stackedFollowButton":"styles_stackedFollowButton__L_q_r"};